import { Component, Input } from '@angular/core';
import { TrackingKeywordSuggestion, KeywordResearchTypes, KeywordConfig, KeywordSuggestion, PageSuggestion } from '../../../../shared/models/keywords/keywords';
import { KeywordResearchService } from '../../../../services/keyword-research.service';

@Component({
  selector: 'app-components-shared-keyword-research-tracking-keywords',
  templateUrl: './tracking-keywords.component.html',
  styleUrls: ['../keyword-research/keyword-research.component.scss']
})
export class TrackingKeywordsComponent {
  @Input() keywordResearchType: KeywordResearchTypes;
  @Input() customer: Boo.Objects.Customer;
  @Input() pageSuggestions: PageSuggestion[];
  @Input() trackingKeywordSuggestions: TrackingKeywordSuggestion[];
  @Input() keywordConfig: KeywordConfig;

  constructor(private keywordResearchService: KeywordResearchService) { }

  keywordSort = (a: KeywordSuggestion, b: KeywordSuggestion): number => this.keywordResearchService.keywordSort(a, b);

  get selectedTrackingKeywordSuggestions(): TrackingKeywordSuggestion[] {
    return this.trackingKeywordSuggestions.filter(x => x.IsSelected && x.IsCampaignNational === this.customer.IsCampaignNational);
  }
}
